export const TOGGLE_LOADING = 'TOP_WINNERS:TOGGLE_LOADING';
export const SET_TOP_WINNERS_DATA = 'TOP_WINNERS:SET_TOP_WINNERS_DATA';

export const setTopWinnersData = (topWinners) => ({
    type: SET_TOP_WINNERS_DATA,
    payload: topWinners
});

export const toggleLoading = (isLoading) => ({
    type: TOGGLE_LOADING,
    payload: isLoading
});
